import axios from "axios";
import { GET_TRANSACTIONS, TRANSACTIONS_FAILED, GET_SUCCESSFUL, SET_TOTAL, SET_TOTAL_SUCCESSFUL, GET_PENDING_TRANSACTIONS } from "./types";

export const getTransactions = () => async (dispatch) => {
  try {
    let data = await axios.get("/getalltransactions");

    // console.log(data.data.transactions);
    dispatch({
      type: GET_TRANSACTIONS,
      payload: data.data.transactions,
    });
    dispatch({
      type: SET_TOTAL,
      payload: data.data.total
    })
  } catch (err) {
    dispatch({
      type: TRANSACTIONS_FAILED,
    });
    console.log(err);
  }
};
export const getSuccessfulTransactions = () => async (dispatch) => {
  try {
    let data = await axios.get("/getsuccessfultransactions");

   
    dispatch({
      type: GET_SUCCESSFUL,
      payload: data.data.transactions,
    });
    dispatch({
      type: SET_TOTAL_SUCCESSFUL,
      payload: data.data.total
    })
  } catch (err) {
    dispatch({
      type: TRANSACTIONS_FAILED,
    });
    console.log(err);
  }
};

export const getPendingTransactions = () => async (dispatch) => {
  try {
    let data = await axios.get("/getpendingtransactions");

    dispatch({
      type: GET_PENDING_TRANSACTIONS,
      payload: data.data.transactions,
    });
  } catch (err) {
    dispatch({
      type: TRANSACTIONS_FAILED,
    });
    console.log(err);
  }
};
